import React from 'react';
import { Router, Route, Switch } from 'dva/router';
import Login from './Login';
import VerificationPage from './routes/Verification';

function RouterConfig({ history }) {
  const DefaultComponent = window.REACT_APP_CONFIG && window.REACT_APP_CONFIG.isFactor ?
    VerificationPage : Login;
  return (
    <Router history={history}>
      <Switch>
        <Route path="/verificationPage" exact component={VerificationPage} />
        <Route path="/*" exact component={DefaultComponent} />
      </Switch>
    </Router>
  );
}

export default RouterConfig;



// WEBPACK FOOTER //
// ./src/router.js